import { LOGOUT } from 'portal-modules/auth/redux/modules/user'

// action types
export const UPDATE_SETTINGS = 'rp/feed/UPDATE_SETTINGS'
export const RECEIVE_SETTINGS = 'rp/feed/RECEIVE_SETTINGS'

// reducer
export default (state = [], { type, payload }) => {
  switch (type) {
    case RECEIVE_SETTINGS:
      return payload.feedSettings
    case UPDATE_SETTINGS:
      return payload
    case LOGOUT:
      return []
    default:
      return state
  }
}

// action creators
export const updateSettings = payload => ({ type: UPDATE_SETTINGS, payload })
export const receiveSettings = payload => ({ type: RECEIVE_SETTINGS, payload })
